import React from 'react';
import { Box, Typography } from '@mui/material';

const NewsIntro = () => {
    return (
        <Box sx={{
            position: 'relative',
            overflow: 'hidden',
            height: '100vh',
            display: 'flex',
            alignItems: 'center', // Centers the title vertically
            justifyContent: 'center', // Centers the title horizontally
            '& > video': {
                width: '100%',
                height: '100vh',
                objectFit: 'cover',
            }
        }}>
            <video autoPlay muted loop style={{ width: '100%', height: '100vh', objectFit: 'cover' }}>
                <source src="https://res.cloudinary.com/self-hosted/video/upload/v1707713471/Beads/news/Beads-for-Education-tembea_ttkvfi.mp4" type="video/mp4" />
            </video>

            <Typography
                variant="h1"
                component="h1"
                sx={{
                    position: 'absolute',
                    color: '#ffffff',
                    textShadow: '2px 2px 8px #000000',
                    fontWeight: 'bold',
                }}
            >
                NEWS
            </Typography>
        </Box>
    );
};

export default NewsIntro;
